import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editLocalisationKeys } from "PFCore/services/admin/localisation/edit_localisation_keys";
import { Id, MutationOptions } from "PFTypes";
import { LocalisationEntry, LocalisationKeys } from "PFTypes";

import { queryKeys } from "./query_keys";

export const useLocalisationKeysEdit = (
  accountId: number,
  key: LocalisationKeys,
  entryId: Id,
  options?: MutationOptions<LocalisationEntry[]>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    queryKeys.localisationEntry(accountId, key, entryId),
    (localisation: LocalisationEntry[]) => editLocalisationKeys(accountId, key, entryId, localisation),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: queryKeys.localisation(accountId, key) });
      }
    }
  );
};
